// extracted by mini-css-extract-plugin
export default {"button":"SNeZb","fullWidthButton":"v96I2"};